import React, { useEffect, useState } from 'react';
import { Printer } from 'lucide-react';
import { usePrinter } from '../../lib/ticketPrinter/printerStore';
import { PrinterPanel, TONE } from './PrinterPanel';

/** Anything can ask for the printer panel — the print sheet does, when the printer needs attention. */
export const OPEN_PRINTER_PANEL = 'open-ticket-printer';
export const openPrinterPanel = () => window.dispatchEvent(new Event(OPEN_PRINTER_PANEL));

/**
 * ONLY WHERE A PRINTER LIVES. Most people using the back office never print a ticket; a permanent
 * "No printer" in their header would be noise they learn to ignore — and then ignore on the day it
 * matters. It appears once a ticket printer has been connected on this computer, and from then on
 * it is the one glance that says whether the next ticket will come out.
 */
export const PrinterChip = () => {
  const p = usePrinter();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener(OPEN_PRINTER_PANEL, h);
    return () => window.removeEventListener(OPEN_PRINTER_PANEL, h);
  }, []);
  const show = p.supported && (p.connected || p.knownPrinter || p.job || p.connectError);
  const s = p.situation;
  return (
    <>
      {show && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          title={[s.headline, s.todo].filter(Boolean).join(' — ')}
          className={`h-8 px-2.5 rounded-md border text-[12px] font-medium inline-flex items-center gap-1.5 shrink-0 ${s.tone === 'red' ? 'border-[#F1D2D2] bg-[#FDF3F2] text-[#9B1F1F]' : s.tone === 'amber' ? 'border-[#F0DDB0] bg-[#FDF8EC] text-[#8A5A00]' : 'border-[#E6E4E1] bg-white text-[#1F2937] hover:bg-[#FAF9F6]'}`}
        >
          <Printer className="w-3.5 h-3.5" strokeWidth={2} />
          <span className={`w-2 h-2 rounded-full ${TONE[s.tone].dot} ${s.tone === 'blue' ? 'animate-pulse' : ''}`} />
          <span className="hidden md:inline">{s.short}</span>
        </button>
      )}
      <PrinterPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
};
